import * as axios from 'axios'

const getAllData = async function () {
  let data
  if (process.env.NODE_ENV === 'development') {
    try {
      const response = await axios.get(process.env.VUE_APP_API)
      data = parseList(response)
      return data
    } catch (error) {
      console.error(error)
      return []
    }
  } else if (process.env.NODE_ENV === 'production') {
    // let billboardData = JSON.parse(document.querySelector("[data-flx-billboard]").dataset.flxBillboard);
    // let billboardData = window.flxBillboard.billboard;
    // let sectionsData = { sections: [] };
    // let data = document.querySelectorAll("*[data-flx-section]");
    // for (let i = 0; i < data.length; i++) {
    //   sectionsData.sections.push(JSON.parse(data[i].dataset.flxSection));
    // }
    // let sectionsData = window.flxSections;

    // console.log(billboardData);
    // console.log(sectionsData);

    // if (billboardData.addCurrentPageInfo == 1) {
    //   sectionsData[0].slides.unshift({
    //     isCurrentPage: true,
    //     id: billboardData.id,
    //     title: billboardData.pageTitle,
    //     subtitle: billboardData.subtitle,
    //     abstract: billboardData.abstract,
    //     smallImage: billboardData.smallImage,
    //     largeImage: billboardData.largeImage,
    //     largeImageSrcSet: billboardData.largeImageSrcSet,
    //     video: billboardData.video,
    //     link: "",
    //     theme: billboardData.theme,
    //     numbered: sectionsData[0].slides.length ? sectionsData[0].slides[0].numbered : "0",
    //   });
    // }

    // data = {
    //   ...billboardData,
    //   ...sectionsData,
    // };

    // console.log(data);

    if (window.flxData.billboard.addCurrentPageInfo == 1) {
      window.flxData.billboard.isCurrentPage = true
      window.flxData.sections[0].slides.unshift(window.flxData.billboard)
    }
    return window.flxData
  }
}

const parseList = (response) => {
  if (response.status !== 200) throw Error(response.message)
  if (!response.data) return []
  let list = response.data
  if (typeof list !== 'object') {
    list = []
  }
  return list
}

export const data = {
  getAllData,
}
